module.exports = __webpack_public_path__ + "static/img/bonus_3.9c0ea31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/bonus_3.png
// module id = M79n
// module chunks = 0